// extracted by mini-css-extract-plugin
export default {"excel_export_button":"styles_excel_export_button__g1190","excel_export_button_font":"styles_excel_export_button_font__x8u89"};